<mat-form-field [formGroup]="formGroup">
  <input matInput hidden [type]="settings.type" [formControlName]="settings.formControlName">
</mat-form-field>
